var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "warning_svg__a",
  d: "M12 20a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2M11 7.054C11 6.47 11.447 6 12 6s1 .471 1 1.053v5.97c0 .582-.447 1.053-1 1.053s-1-.472-1-1.053zm12.67 12.268L13.966 2.18c-.89-1.574-3.04-1.574-3.932 0L.33 19.32c-.917 1.62.184 3.68 1.966 3.68h19.408c1.782 0 2.883-2.06 1.966-3.68"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#warning_svg__a",
  fill: "#fff",
  fillRule: "evenodd"
})));
export default SvgWarning;